import type { PdfProps } from 'features/reporting/types'
import { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import React from 'react'

import { AddendumContentPages } from './AddendumContentPages'
import { ImagePageHeader } from './ImagePageHeader'

interface AddendumPagesProps {
  sectionId: string
  sectionTitle: string
  onRender?: PdfProps['onRender']
}

export const AddendumPages: React.FC<AddendumPagesProps> = ({
  sectionId,
  sectionTitle,
  onRender,
}) => {
  const { formData, addendumImageSources } = useRugReportOps()
  const addendums = (formData.sectionAddendums ?? []).filter(
    (addendum) => addendum.sectionId === sectionId
  )
  if (addendums.length === 0) return null

  return (
    <AddendumContentPages
      sectionId={sectionId}
      sectionTitle={sectionTitle}
      addendums={addendums}
      jobNumber={formData.mainInfo.jobNumber}
      revisionNumber={formData.revisionMetadata.revisionNumber}
      imageHeader={<ImagePageHeader />}
      imageSources={addendumImageSources}
      onRender={onRender}
    />
  )
}
